export enum URLS {
  App = '/app',
  AppCloudVk = 'https://msk.cloud.vk.ru/app',
  AppKz = 'https://cloud.vk.ru/authapp',
  AppKzSignIn = 'https://cloud.vk.ru/authapp/signin?region_name=kz',
  AppKzSignUp = 'https://cloud.vk.ru/authapp/signup?region_name=kz',
  AppSignIn = '/app/signin',
  AppSignOut = '/app/signout',
  AppSignUp = '/app/signup',
  HelpPrivacy = 'https://help.mail.ru/legal/terms/potentialpartners/ru/',
  Docs = '/docs',
  Blog = '/blog',
  BlogCategory = '/blog/hubs',
  Form = '/form',
  Index = '/',
  IndexEn = '/en/',
  OriginCloudVk = 'https://cloud.vk.ru',
  OriginKz = 'https://vkcloud.kz',
  OriginHrtek = 'https://hrtek.vk.ru',
  Page404 = '/404',
  SuccessStory = '/cloud-platform/success-story',
  CloudPlatform = '/cloud-platform',
  Vkdoc = 'https://vkdoc.mail.ru/',
  Vktech = 'https://tech.vk.ru/',
  HrTekSupport = 'mailto:support@hrtek.ru',
  FosBatut = '/bitrixLeadAdd/',
}
